import { useAuth } from '../context/AuthContext.tsx';

/**
 * Custom hook to check if current user has premium access
 * @returns boolean indicating premium status
 */
export const usePremium = (): boolean => {
  const { user, isAuthenticated } = useAuth();

  // User must be authenticated and have premium flag set to true
  return isAuthenticated && user?.isPremium === true;
};

export default usePremium;
